import { useNavigate } from 'react-router-dom';
import Page from '..';
import Card from '../../Card';
import PageToolsPrice from './Price';
import './Tools.css';
import {
  CardLock,
  CardToolsColumn,
  CardToolsImagem,
  TitleTolls,
} from './styled';
import produtoVector from '../../../images/Group13.png';
import catalogoVector from '../../../images/catalagoProduto.png';
import etiquetaVector from '../../../images/etiquetaadd.png';
import encarttaVector from '../../../images/encartAdd.png';
import validadeVector from '../../../images/validade.png';
import admVector from '../../../images/adm.png';
import admlojaVector from '../../../images/adm loja.png';
import suporteVector from '../../../images/admsuporte.png';
import exportIcon from '../../../images/export-icon.png';
import { useAbility } from '../../Hooks/useAbility';
import useStore from '../../Hooks/useStore';

export default Object.assign(
  () => {
    const navigate = useNavigate();
    const { Can } = useAbility();
    const [getters] = useStore();
    const {
      user: { getSelectedClient, getSelectedFilial },
    } = getters;

    const client = getSelectedClient();
    const filial = getSelectedFilial();

    const defaultPricePermission = !!(filial && client);
    const defaultBannerPermission = !!(filial && client && client.banner);

    return (
      <Page
        className="page-tools"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="tools">Ferramentas</div>
        <Card.Container
          className="card-tools-container"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            width: 'fit-content',
            gap: '20px',
          }}
        >
          <CardToolsColumn
            onClick={() => defaultPricePermission && navigate('/tools/price')}
          >
            <CardToolsImagem src={catalogoVector} />
            <TitleTolls>Catalogo de Produtos</TitleTolls>
            {!defaultPricePermission ? <CardLock color="#808080" /> : null}
          </CardToolsColumn>
          <CardToolsColumn
            onClick={() => defaultBannerPermission && navigate('/tools/banner')}
          >
            <CardToolsImagem src={produtoVector} />
            <TitleTolls>Gerador de Cartaz</TitleTolls>
            {!defaultBannerPermission ? <CardLock color="#808080" /> : null}
          </CardToolsColumn>
          <CardToolsColumn>
            <CardToolsImagem src={etiquetaVector} />
            <TitleTolls>Gerador de Etiqueta</TitleTolls>
            <CardLock color="#808080" />
          </CardToolsColumn>
          <CardToolsColumn>
            <CardToolsImagem src={encarttaVector} />
            <TitleTolls>Gerador de Encartes</TitleTolls>
            <CardLock color="#808080" />
          </CardToolsColumn>
          <Can I="read" a="Invoice" passThrough>
            {(allowedInvoice) => (
              <Can I="read" a="Logistic" passThrough>
                {(allowedLogistic) => (
                  <CardToolsColumn
                    onClick={
                      () => allowedInvoice
                        ? navigate('/tools/exports')
                        : allowedLogistic
                          ? navigate('/tools/exports/logistic')
                          : null
                    }
                  >
                    <CardToolsImagem src={exportIcon} />
                    <TitleTolls>Exportações</TitleTolls>
                    {!(allowedInvoice || allowedLogistic) ? <CardLock color="#808080" /> : null}
                  </CardToolsColumn>
                )}
              </Can>
            )}
          </Can>
          <Can I="read" a="Validity" passThrough>
            {(allowed) => (
              <CardToolsColumn
                onClick={() =>
                  allowed && navigate('/tools/validity/validities')
                }
              >
                <CardToolsImagem src={validadeVector} />
                <TitleTolls>Gestão de validades</TitleTolls>
                {!allowed ? <CardLock color="#808080" /> : null}
              </CardToolsColumn>
            )}
          </Can>
          <CardToolsColumn>
            <CardToolsImagem src={admVector} />
            <TitleTolls>ADM Consulta.AI </TitleTolls>
            <CardLock color="#808080" />
          </CardToolsColumn>
          <CardToolsColumn>
            <CardToolsImagem src={suporteVector} />
            <TitleTolls>ADM SuperAPP </TitleTolls>
            <CardLock color="#808080" />
          </CardToolsColumn>
          <CardToolsColumn>
            <CardToolsImagem src={admlojaVector} />
            <TitleTolls>ADM Loja Virtual </TitleTolls>
            <CardLock color="#808080" />
          </CardToolsColumn>
        </Card.Container>
      </Page>
    );
  },
  {
    Price: PageToolsPrice,
  },
);
